import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import of spanish
import global_es from './translations/es/global.json';
import dashboard_es from './translations/es/dashboard.json';
import account_es from './translations/es/account.json';
import analytics_es from './translations/es/analytics.json';
import finance_es from './translations/es/finance.json';
import sidebar_es from './translations/es/sidebar.json';
import navbar_es from './translations/es/navbar.json';
// import of english
import global_en from './translations/en/global.json';

const resources = {
  en: {
    global: global_en
  },
  es: {
    global: global_es,
    dashboard: dashboard_es,
    account: account_es,
    analytics: analytics_es,
    finance: finance_es,
    sidebar: sidebar_es,
    navbar: navbar_es
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'es',
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    }
  });
